export const ADJUSTMENT_POSITIVE = ['552', '945'];
export const ADJUSTMENT_NEGATIVE = ['551', '944'];
